import React from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import DashboardIcon from '../../../assets/images/icons/ico_dashboard_small.svg'
import CommunityIcon from '../../../assets/images/icons/ico_community_small.svg'
import HomeDetailIcon from '../../../assets/images/icons/ico_home-detail_small.svg'
import SensorIcon from '../../../assets/images/icons/ico_sensor-small.svg'

class TutorialStep3 extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    root: theme.introCardRoot,
    content: {
      ...theme.introCardContent,
      '& ul': {
        paddingInlineStart: 'unset',
      },
    },
    list: {
      padding: theme.spacing(0),
    },
    listItem: {
      padding: theme.spacing(0),
      margin: theme.spacing(1, 0),
    },
    listItemIcon: {
      minWidth: 'unset',
      width: '70px',
      height: '70px',
      background: '#000',
      color: '#fff',
      marginRight: '16px',
      '& svg, & img': {
        height: '40px',
        margin: 'auto',
      },
    },
    listItemText: {
      margin: theme.spacing(0),
    },
  })

  render() {
    const { classes } = this.props

    return (
      <Card square elevation={3} classes={{ root: classes.root }}>
        <CardContent className={classes.content}>
          <Typography variant="h1">
            Navigating Communities, Homes, and Sensors
          </Typography>
          <Typography variant="h2">
            Sensors, alerts, and reports to help you quickly identify and respond to safety and
            performance issues in your comunity.
          </Typography>
          <p>
            Information in the BlokSense Insights Dashboard is organized by community, home, and sensor.
            Here&#8217;s an overview of the tools and data available for each level:
          </p>
          <List className={classes.list}>
            <ListItem className={classes.listItem}>
              <ListItemIcon className={classes.listItemIcon}>
                <img src={DashboardIcon} alt="dashboard icon" />
              </ListItemIcon>
              <ListItemText
                className={classes.listItemText}
                primary="Dashboard"
                secondary="View all alerts across communities and at-a-glance community status."
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemIcon className={classes.listItemIcon}>
                <img src={CommunityIcon} alt="community icon" />
              </ListItemIcon>
              <ListItemText
                className={classes.listItemText}
                primary="Community Detail"
                secondary="View community alerts, subscribe to email alerts, view aggregate power usage."
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemIcon className={classes.listItemIcon}>
                <img src={HomeDetailIcon} alt="home detail icon" />
              </ListItemIcon>
              <ListItemText
                className={classes.listItemText}
                primary="Home Detail"
                secondary="View power usage, select a sensor."
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemIcon className={classes.listItemIcon}>
                <img src={SensorIcon} alt="sensor icon" />
              </ListItemIcon>
              <ListItemText
                className={classes.listItemText}
                primary="Sensor Detail"
                secondary="View sensor output: air quality, door access, power usage, hub status, humidty level, CO detection, fire sprinkler activity, smoke detection, and temperature."
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>
    )
  }
}

export default withStyles(TutorialStep3.styles)(TutorialStep3)
